$(document).ready(function() {

  closeMenu();

  $( '.close-menu, .black-screen').bind( 'touchstart click' , function(e) {
    e.preventDefault();
    closeMenu();
  } );

  $( '#logo_soolid').bind( 'touchstart click' , function(e) {
    e.preventDefault();
    openMenu();
  } );

});

$(document).keyup(function(e) {
  if (e.keyCode == 27) {
    closeMenu();
  }
});



/*
 * Open menu
 */

function openMenu() {

  $(".black-screen, .close-menu__button").stop(true,true).fadeIn('fast');

  $('nav').css( {'opacity':1, display:'block'} );

  TweenMax.to('nav', 0.3, {
    ease: Circ.easeIn, x: 0,
    onComplete:function() {
      TweenMax.staggerTo( "nav h1, nav div p, nav li, .piva", 0.2, {
        x:0,
        opacity: 1,
        ease:Back.easeOut
      }, 0.1 );
    }
  });

}

/*
 * Close menu
 */

function closeMenu() {

    TweenMax.to('nav', 0.3, {
      ease:  Circ.easeOut,
      x: $('nav').outerWidth(),

      onComplete: function() {

        TweenMax.staggerTo( "nav h1, nav div p, nav li, .piva", 0.2,
          {
            x:100,
            opacity: 0,
            ease:Back.easeIn
          },
          0.1
        );

        $('nav').css( {'opacity':1, display:'block'} );

      }

    }, 0.1 );

    $(".black-screen, .close-menu__button").stop(true,true).fadeOut('fast');

}



//////////////////
// WEBPACK FOOTER
// ./js/modules/nav-menu.js
// module id = 30
// module chunks = 0